var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 6,
    fill: "#00B0C8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1396_4970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 9.74997V11.75C6 12.165 6.335 12.5 6.75 12.5C7.165 12.5 7.5 12.165 7.5 11.75V9.74997C7.5 9.33497 7.165 8.99997 6.75 8.99997C6.335 8.99997 6 9.33497 6 9.74997ZM9 9.74997V11.75C9 12.165 9.335 12.5 9.75 12.5C10.165 12.5 10.5 12.165 10.5 11.75V9.74997C10.5 9.33497 10.165 8.99997 9.75 8.99997C9.335 8.99997 9 9.33497 9 9.74997ZM5.75 15H13.75C14.165 15 14.5 14.665 14.5 14.25C14.5 13.835 14.165 13.5 13.75 13.5H5.75C5.335 13.5 5 13.835 5 14.25C5 14.665 5.335 15 5.75 15ZM12 9.74997V11.75C12 12.165 12.335 12.5 12.75 12.5C13.165 12.5 13.5 12.165 13.5 11.75V9.74997C13.5 9.33497 13.165 8.99997 12.75 8.99997C12.335 8.99997 12 9.33497 12 9.74997ZM9.285 4.74497L5.335 6.82497C5.13 6.92997 5 7.14497 5 7.37497C5 7.71997 5.28 7.99997 5.625 7.99997H13.88C14.22 7.99997 14.5 7.71997 14.5 7.37497C14.5 7.14497 14.37 6.92997 14.165 6.82497L10.215 4.74497C9.925 4.58997 9.575 4.58997 9.285 4.74497Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1396_4970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/bank_icon.e93649406ec6a02e0e880406a3cda5d9.svg";
export { ForwardRef as ReactComponent };